import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import YachtHelper from '../../../../../helpers/Yacht';
import cls from './yachtApply.module.scss';

function Yacht({ myYacht, isOfferLine, showDescription, baseClass }) {
  const yachtHelper = new YachtHelper(myYacht);
  const { t } = useTranslation();

  let containerClass = '';

  if (baseClass) {
    containerClass = ` ${cls[baseClass]}`;
  }

  return (
    <div className={containerClass}>
      <div className={cls.yacht_info}>
        <div className={cls.yacht_info_left}>
          <div className={cls.yacht_info_img}>
            <picture>
              <source
                srcSet={yachtHelper.getMainImage('520_320_crop', 'webp')}
                type="image/webp"
              />
              <source
                srcSet={yachtHelper.getMainImage('520_320_crop')}
                type="image/jpeg"
              />
              <img
                src={yachtHelper.getMainImage('520_320_crop')}
                alt={yachtHelper.getTitle()}
              />
            </picture>
          </div>
        </div>
        <div className={cls.yacht_description}>
          {/* {!isPurchase && ( */}
          <p className={isOfferLine ? cls.offer_line_link : ''}>
            {myYacht.title}
          </p>
          {/* )} */}
          <span>{`${t('create.step6.brand')}: ${myYacht.vendor}`}</span>
          <span>{`${t('create.step6.model')}: ${myYacht.model}`}</span>
          <span>{`${t('create.step6.cabins')}: ${myYacht.cabin}`}</span>
          <span>{`${t('create.step6.sleepingPlaces')}: ${myYacht.place}`}</span>
        </div>
      </div>
      {showDescription ? (
        <div className={cls.yacht_description_real}>
          {yachtHelper.getDescription(400, true)}
        </div>
      ) : (
        ''
      )}
      {/* {isPurchase && (
        <p className={isOfferLine ? cls.offer_line_link : ''}>
          {myYacht.title}
        </p>
      )} */}
    </div>
  );
}

Yacht.propTypes = {
  myYacht: PropTypes.shape().isRequired,
  // isPurchase: PropTypes.bool,
  isOfferLine: PropTypes.bool,
  showDescription: PropTypes.bool,
  baseClass: PropTypes.string,
};

Yacht.defaultProps = {
  // isPurchase: false,
  isOfferLine: false,
  showDescription: false,
  baseClass: null,
};

export default Yacht;
